import { motion } from "framer-motion"
import { Box } from "@chakra-ui/react"

export const MotionBox = motion(Box)
